import { connect } from 'react-redux'

import { getUserOrderById } from 'utils/user'

import { OrderDetails } from './OrderDetails'

function mapStateToProps(state: any) {
  const orderId = state.basket.get('orderId')
  const order = getUserOrderById(orderId, state.user.get('orders'))

  return {
    deliveryDate: order.get('deliveryDate'),
    numRecipes: parseFloat(order.getIn(['box', 'numRecipes']) as string),
    recipeItems: order.get('recipeItems'),
    recipes: state.recipes,
    line1: order.getIn(['shippingAddress', 'line1']) as string,
    town: order.getIn(['shippingAddress', 'town']) as string,
    postcode: order.getIn(['shippingAddress', 'postcode']) as string,
    orderNumber: orderId,
    percentgeOff: order.getIn(['prices', 'percentageOff']) as number,
    recipeTotal: order.getIn(['prices', 'recipeTotal']) as number,
    totalDiscount: order.getIn(['prices', 'totalDiscount']) as number,
    deliveryTotal: order.getIn(['prices', 'deliveryTotal']) as number,
    total: order.getIn(['prices', 'total']) as number,
  }
}

const OrderDetailsContainer = connect(mapStateToProps)(OrderDetails)

export { OrderDetailsContainer as OrderDetails }
